export {};

export const PATH_ROOT: string = "/";

// サイドバー
export const SIDE_PANEL_NUMBER = {
  Management: 1,
  PATH_HOME_BOARD: 2,
  ORDER_LIST: 3,
};

// 推移グラフタブ番号
export const TRANSITION_TAB_NUMBER = {
  REMAINING_AMOUNT_TAB: 1,
  USAGE_AMOUNT_TAB: 2,
};

// 薬剤管理用途定義
export const CHEMICAL_MANAGEMENT_TYPE = {
  TANK: 1, // 貯槽系管理
  BOX: 2, // 箱系管理
  BOX_AND_TANK: 3, // 箱系＋貯槽系管理
};

// 薬剤アイコンイメージ定義
export const CHEMICAL_ICON_IMAGE = {
  TANK: 1, // タンク
  BOX: 2, // 箱
  BAG: 3, // 袋
  CAN: 4, // 缶
  CYLINDER: 5, // ボンベ
};

// 土日祝ビットフラグ定義
export const HOLIDAY_BITS = {
  SATURDAY: 1,
  SUNDAY: 2,
  WEEKEND: 3,
  HOLIDAY: 4,
  SATURDAY_HOLIDAY: 5,
  SUNDAY_HOLIDAY: 6,
  WEEKEND_AND_HOLIDAY: 7,
};

export const MESSAGES = {
  CONFIRM_LOGOUT: "ログアウトしてよろしいでしょうか",

  ERROR_MESSAGE_DIALOG_UNHANDLED: "処理中にエラーが発生しました。", // メッセージダイアログの非同期処理中の例外スロー時
  ERROR_SERVER: "サーバー処理中にエラーが発生しました。",
  ERROR_AUTH: "ユーザIDとパスワードが一致しません。",
  ERROR_SESSION_TIMEOUT: "セッションがタイムアウトしました。ログインページに戻ります。",
  ERROR_PERMISSION: "権限がありません。",

  ERROR_INPUT_EMPTY: "すべての項目を入力してください。",
  ERROR_INPUT_INVALID: "正しい値を入力してください。",
  ERROR_INPUT_BATCH_ORDER_MAX: "一括発注上限数を超えています。",

  ERROR_GET: "データ取得に失敗しました。",
  ERROR_POST: "登録に失敗しました。",
  ERROR_DELETE: "削除に失敗しました。",

  ERROR_ORDER_RESULT_DOWNLOAD: "納入締め日が登録されていません。",
  ERROR_CHEMICAL_VENDOR_NONE: "薬剤販売業者が登録されていません。",
  ERROR_CHEMICAL_TYPE_NONE: "薬剤カテゴリが登録されていません。",

  WARNING_INPUT_MIN_AMMOUNT: "発注最低数量を下回っています。発注登録を実行しますか？",
  WARNING_INPUT_INVALID_DATE:
    "リードタイム未満の納入予定日が指定されています。発注登録を実行しますか？",
  WARNING_INPUT_INVALID_DAY: "搬入対応不可日が指定されています。発注登録を実行しますか？",

  SUCCESS_ORDER_DOWNLOAD: "発注書をダウンロードしました",
  SUCCESS_ORDER_RESULT_DOWNLOAD: "納入実績表をダウンロードしました",
  SUCCESS_ORDER_PLAN_DOWNLOAD: "年間調達計画・実績表をダウンロードしました",
  SUCCESS_PROCESS_PLAN_UPLOAD: "焼却量計画データをアップロードしました",
  SUCCESS_POST: "登録が完了しました",
};

export const ENVIRONMENTS = {
  LOCAL: "LOCAL",
  DEV: "DEVELOP",
  STG: "STAGING",
  PROD: "PRODUCTION",
} as const;

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const LAMBDA_URL = import.meta.env.VITE_LAMBDA_URL;
export const X_API_KEY = import.meta.env.VITE_X_API_KEY;
export const ENV_TITLE_TEXT = import.meta.env.VITE_ENV_TITLE_TEXT;
